import { Link } from 'react-router-dom'
import { Breadcrumb ,message, Form,
  Input,
  InputNumber,
  Cascader,
  Row,
  Col,
  Checkbox,
  Button,
  AutoComplete, 
  ConfigProvider} from 'antd';
import copy from "copy-to-clipboard";
import './RefundPolicy.less'
import {post} from '../../request/request'
import { useIntl } from 'react-intl';

const handleCopy = (value:any) => {
	copy(value);
	message.success('Copy successful!');
}


const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 24 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
};


export default () => {
	const [form] = Form.useForm();
	const intl = useIntl();
	const onFinish = (values: any) => {
		post('snailcar/info/common/contactSnailCar',{...values
	}).then((data) => {
		console.log(data)
		message.success('successful!');
		form.resetFields();
	})
	};
	return (
	<div className="RefundPolicy">
		<div className="page-routers-header">
			<Breadcrumb className="page-header-content">
				<Breadcrumb.Item>
				  <a href="/">{intl.formatMessage({id: 'header.menus.home'})}</a>
				</Breadcrumb.Item>
				<Breadcrumb.Item>{intl.formatMessage({id: 'footer.menus.about.Contact'})}</Breadcrumb.Item>
			</Breadcrumb>
		</div>
		<div className="page-footer-container">
			<div className="page-footer-content">
				<div className="page-title">{intl.formatMessage({id: 'contact.title'})}</div>
				<div>
					<div className="content-block" style={{textAlign: 'center'}}>
						<p className="title" style={{fontWeight: 400}}>{intl.formatMessage({id: 'contact.con1'})}<br/>{intl.formatMessage({id: 'contact.con2'})}<br/>{intl.formatMessage({id: 'contact.con3'})}<br/>{intl.formatMessage({id: 'contact.con4'})}</p>
						<p className="title">{intl.formatMessage({id: 'contact.now'})}</p>
						<div className="inline-block-right content-block-right">
							<div className="right-block">{intl.formatMessage({id: 'contact.message'})}</div>
							<div className="right-block">
								<p>{intl.formatMessage({id: 'distributor.email'})} <br/>support@snailcle.com</p>
								<p>{intl.formatMessage({id: 'distributor.phone'})} <br/>0086 592 6261321</p>
							</div>
							<div className="right-block">
								<p>{intl.formatMessage({id: 'distributor.workingHours'})} <br/>{intl.formatMessage({id: 'distributor.workingHours.con'})}</p>
							</div>
						</div>
						<div className="inline-block-left content-block-left">
						<ConfigProvider
						// theme={{
						// 	token: {
						// 	colorPrimary: '#647283',
						// 	},
						// }}
						>
							<Form
							  form={form}
							  layout="vertical"
							  name="register"
							  onFinish={onFinish}
							  initialValues={{
							    residence: ['zhejiang', 'hangzhou', 'xihu'],
							    prefix: '86',
							  }}
							  scrollToFirstError
							  style={{width: '100%',maxWidth: '450px'}}
							>
							  <Form.Item
							    name="name"
							    label={intl.formatMessage({id: 'form.label.Name'})}
							  >
							    <Input />
							  </Form.Item>

							  <Form.Item
							    name="phone"
							    label={intl.formatMessage({id: 'form.label.Phone'})}
							    rules={[{ required: true, message: intl.formatMessage({id: 'form.btn.sub'}) }]}
							  >
							    <Input style={{ width: '100%' }} />
							  </Form.Item>

							  <Form.Item
							    name="email"
							    label={intl.formatMessage({id: 'form.label.email'})}
							    rules={[
							      {
							        type: 'email',
							        message: intl.formatMessage({id: 'form.message.valid.email'}),
							      },
							      {
							        required: true,
							        message: intl.formatMessage({id: 'form.message.enter.email'}),
							      },
							    ]}
							  >
							    <Input />
							  </Form.Item>

							  <Form.Item
							    name="comment"
							    label="Your Comment"
							    rules={[{ required: true, message: intl.formatMessage({id: 'form.message.comment'}) }]}
							  >
							    <Input.TextArea placeholder={intl.formatMessage({id: 'form.message.enter.comment'})} style={{minHeight: '120px'}} />
							  </Form.Item>
							  <Form.Item >
							    <Button type="primary"  htmlType="submit" shape="round" block>{intl.formatMessage({id: 'form.btn.sub'})}</Button>
							  </Form.Item>
							</Form>
							</ConfigProvider>
						</div>
						<div style={{clear: 'both'}}></div>
					</div>
				</div>
			</div>
		</div>
	</div>
)}